import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=f4c57c2c"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c57c2c')) {
      api.createRecord('f4c57c2c', component.options)
    } else {
      api.reload('f4c57c2c', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=f4c57c2c", function () {
      api.rerender('f4c57c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/whitelist-ip/dialog-form-wrapper.vue"
export default component.exports